import FilterColIcon from '../../../icons/filterapplied-col-icon.svg';

const filterApplied = (IsFilterApplied: boolean): string => {
    return `<div class="ag-cell-label-container" role="presentation">
						<div ref="eLabel" class="ag-header-cell-label" role="presentation">
                        <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>
                        <span ref="eSortOrder" class="ag-header-icon ag-header-label-icon ag-sort-order" aria-hidden="true"></span>
							<span ref="eSortAsc" class="ag-header-icon ag-header-label-icon ag-sort-ascending-icon" aria-hidden="true"></span>
							<span ref="eSortDesc" class="ag-header-icon ag-header-label-icon ag-sort-descending-icon" aria-hidden="true"></span>
							<span ref="eSortNone" class="ag-header-icon ag-header-label-icon ag-sort-none-icon" aria-hidden="true"></span> 
                            ${IsFilterApplied ? `<img src=${FilterColIcon} class="ml-auto" />` : ""}
                            </div>
					</div>`
}





const plansAddOn = `<div class="ag-cell-label-container" role="presentation">
                    <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                    <span class="d-flex ag-header-cell-text">
                    <span class='color-plan-text'>Plans</span>/<span class='color-primary-warning'>Add-On</span>
                    </span>
                    <span ref="eSortOrder" class="ag-header-icon ag-header-label-icon ag-sort-order" aria-hidden="true"></span>
                        <span ref="eSortAsc" class="ag-header-icon ag-header-label-icon ag-sort-ascending-icon" aria-hidden="true"></span>
                        <span ref="eSortDesc" class="ag-header-icon ag-header-label-icon ag-sort-descending-icon" aria-hidden="true"></span>
                        <span ref="eSortNone" class="ag-header-icon ag-header-label-icon ag-sort-none-icon" aria-hidden="true"></span>
                        </div>
                </div>`

export const dateComparator = (date1, date2) => {
    const date1Number = Number(new Date(date1));
    const date2Number = Number(new Date(date2));
    if (date1Number === null && date2Number === null) {
        return 0;
    }
    if (date1Number === null) {
        return -1;
    }
    if (date2Number === null) {
        return 1;
    }
    return date1Number - date2Number;
}

export const HeaderTemplate = {
    filterApplied,
    plansAddOn,
}
